import React from 'react';
import { styled } from '@teko/ds-desktop';
import { DSSize } from '@teko/types/shared';
import { BlockHeader } from '../../BlockHeader/BlockHeader.es.js';
import { Countdown } from '../../Countdown/Countdown.es.js';
import { ProductCarousel } from '../../ProductCarousel/ProductCarousel.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FlashSale = ({
  productsCarousel,
  endAt,
  backgroundImage,
  title
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    bgImage: backgroundImage || "https://shopfront-cdn.tekoapis.com/static/washing_machine.png"
  }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(BlockHeader, {
    title: title || ""
  }), /* @__PURE__ */ React.createElement(Countdown, {
    date: endAt || new Date(),
    size: DSSize.medium
  })), /* @__PURE__ */ React.createElement(ProductCarousel, __spreadValues({}, productsCarousel)));
};
const Wrapper = styled.div`
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 8px;
  .product-card {
    background: white;
    border-radius: 8px;
  }
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  justify-content: space-between;
`;

export { FlashSale };
